import type { FC, ReactNode } from 'react'
import type { OverviewData } from '@/data/metrics'

import { formatNumber, formatSignedRupiahCompact } from '@/lib/format'
import { SectionCard } from '@/components/dashboard/section-card'
import { DivergingBarList } from '@/components/charts/diverging-bar-list'
import { ChartLegend } from '@/components/charts/chart-tooltip'

interface MrrMovementCardProps {
    data: OverviewData
    className?: string
}

export const MrrMovementCard: FC<MrrMovementCardProps> = ({ data, className }): ReactNode => {
    const { movement } = data

    const items = [
        { key: 'new', label: 'MRR baru', description: `${formatNumber(data.newCustomers)} pelanggan baru`, value: movement.newMrr },
        { key: 'expansion', label: 'Ekspansi', description: 'Naik paket dan tambah pengguna', value: movement.expansionMrr },
        { key: 'contraction', label: 'Kontraksi', description: 'Turun paket dan kurangi pengguna', value: -movement.contractionMrr },
        { key: 'churn', label: 'Churn', description: `${formatNumber(data.churnedCustomers)} pelanggan berhenti`, value: -movement.churnedMrr }
    ]

    return (
        <SectionCard
            className={className}
            title='Pergerakan MRR'
            description={`Asal perubahan MRR selama ${data.label} terakhir.`}
            footer={(
                <div className='flex items-center justify-between gap-3 text-sm'>
                    <span className='font-medium text-foreground'>
                        MRR bersih
                    </span>
                    <span className='font-heading text-base font-semibold text-foreground tabular-nums'>
                        {formatSignedRupiahCompact(movement.net)}
                    </span>
                </div>
            )}
        >
            <ChartLegend
                className='mb-4'
                items={[
                    { key: 'gain', label: 'Menambah MRR', color: 'var(--chart-2)' },
                    { key: 'loss', label: 'Mengurangi MRR', color: 'var(--chart-1)' }
                ]}
            />

            <DivergingBarList items={items} formatValue={formatSignedRupiahCompact} />
        </SectionCard>
    )
}
